module.exports = __webpack_public_path__ + "static/img/tools_bg01.95b9f320.png";